export const authProviders = {
  APPLE: 'apple',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  ODDSCHECKER: 'oddschecker',
  WHOSCORED: 'whoscored',
} as const;

export type AuthProvider = (typeof authProviders)[keyof typeof authProviders];
